import { render, staticRenderFns } from "./Sitegroup.vue?vue&type=template&id=54cd0b55"
import script from "./Sitegroup.vue?vue&type=script&lang=js"
export * from "./Sitegroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports